module.exports = __webpack_public_path__ + "img/scroll.b9fc570c.svg";